export const zeroPad = (num: number) => {
  return String(num).padStart(2, '0');
};
